import React, { useState } from "react";

import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";

import ClipLoader from "react-spinners/ClipLoader";

import "../../css/createSourceModal.css";
import {
    getZendeskUrl,
    sendDataZendesk,
} from "../../helpers/Sources/zendesk/zendeskSource";
import CrmSourceMappingArea from "../CrmSourceMappingArea";
import LoginButton from "../molecules/LoginButton";
import SwalAlertComp from "../SwalAlert";

const ZendeskSource = (props) => {
    const { useHostFooter = false, registerFooterAction } = props;
    const [zendeskName, setZendeskName] = useState("");
    const [zendeskBtn, setZendeskBtn] = useState(false);
    const [zendeskCheck, setZendeskCheck] = useState(false);
    const [zendeskId, setZendeskId] = useState("");

    const sendZendeskData = async (data) => {
        let newData = {
            name: zendeskName,
            state: data?.state,
            code: data?.code,
            usage_types: [4],
        };
        let response = await sendDataZendesk(newData);
        if (response.status) {
            setZendeskCheck(true);
            setZendeskBtn(false);
            if (props.selectFileSourceId) {
                props.selectFileSourceId(
                    response?.data?.source?.id,
                    response?.data?.source?.source_type_id,
                );
            }
            setZendeskId(response?.data?.source?.id);
        } else {
            SwalAlertComp({
                title: "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
        }
    };

    const handleZendeskName = (e) => {
        const inputValue = e.target.value;
        setZendeskName(inputValue);
        setZendeskBtn(true);
    };

    const saveCrmMapping = (response) => {
        if (props?.setLoading !== undefined) {
            props?.setLoading(true);
        }
        if (response.status) {
            SwalAlertComp({
                title: "Success",
                message: response.message && response.message,
                icon: "success",
                timer: 3000,
            });
            setZendeskBtn(false);
            setZendeskName("");
            setZendeskId("");
            setZendeskCheck(false);
            if (props.handleGetSources) {
                props.handleGetSources();
            }
            if (props.getAllSourcesReduxProps) {
                props.getAllSourcesReduxProps();
            }
            if (props.getTracker) {
                props.addToTracker(zendeskId);
            }
            if (props.setNextCheck) {
                props.setNextCheck(true);
            }
            props?.handleClose(zendeskId);
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        } else {
            SwalAlertComp({
                title: "Failed",
                message: response?.message ?? "",
                icon: "error",
            });
            if (props?.setLoading !== undefined) {
                props?.setLoading(false);
            }
        }
    };

    return (
        <div>
            {zendeskCheck ? (
                <>
                    <CrmSourceMappingArea
                        sourceId={zendeskId}
                        sourceType={"zendesk_sell"}
                        mappingSuccess={saveCrmMapping}
                        isModal={props?.isModal}
                        hideSaveButton={useHostFooter}
                        registerFooterAction={registerFooterAction}
                    />
                </>
            ) : (
                <>
                    <FormControl className="mb-3" style={{ width: "100%" }}>
                        <TextField
                            name="zendeskName"
                            label={"Name"}
                            variant="outlined"
                            onChange={handleZendeskName}
                            placeholder={"Please Write Name"}
                            value={zendeskName}
                        />
                    </FormControl>
                    <div className="position-relative overflow-hidden z-1">
                        {props.isButtonLoader !== undefined &&
                            props.isButtonLoader && (
                                <div className="circle-loader">
                                    <ClipLoader color={"#000"} size={17} />
                                </div>
                            )}
                        <LoginButton
                            getAuthUrl={getZendeskUrl}
                            getAuthUrlResponseTransform={(response) => {
                                return response?.data?.auth_url;
                            }}
                            code="zendesk_sell"
                            paramNames={["code", "state"]}
                            onSuccess={sendZendeskData}
                            dataTransform={(params) => ({
                                code: params.code,
                                state: params.state,
                            })}
                            onLoadingChange={props?.setIsButtonLoader}
                            logoSrc="/assets/images/zendesk-icon.png"
                            logoStyle={{
                                borderRadius: "50%",
                            }}
                            buttonText={"Connect with Zendesk Sell"}
                            disabled={!zendeskBtn}
                            isLoadingExternal={props?.isButtonLoader}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default ZendeskSource;
